import './index.scss';
import Nav from 'components/Nav';
import ProductItem from 'components/ProductItem';
import MoreTitle from '../more';
import './index.scss';
import {observer, inject} from 'mobx-react';
import ModuleTitle from '../ModuleTitle';
@inject(({store}) => ({
    sqwzb: store.sqwzb,
    tabClick: store.tabClick,
    jump: store.jump,
    ymbj: store.ymbj
}))
@observer
class AroundRecommend extends React.Component {
    tabClick(keyName, key) {
        this.props.tabClick('sqwzb', keyName, key);
    }
    getTypeValue(data) {
        let dpj = '', lvj = '', result;
        result = data.filter(v => {
            if(v.display === undefined && !v.display.includes('mobile_list')) {
                return false;
            }

            if(v.tag_type === 'shopAllianceCoupon' && v.type === 'sales') {
                !dpj && v.amount && (dpj = (v.reduce_type === 1 ? '每满' : '满') + v.amount + '减' + v.reduce);
                return false;
            }

            if(v.tag_type === 'promotion' && v.type === 'sales') {
                !lvj && v.money && (lvj = '最高 满' + v.money + '减' + v.reduce);
                return false;
            }
            return true;
        });
        // 对象数组去重
        let dataSum = [];
        result = result.filter((t) => {
            if(dataSum.includes(t.title)) return false;
            dataSum.push(t.title);
            return true;
        });
        return {
            dpj,
            lvj,
            result
        };
    }
    pRend(data) {
        const {ymbj} = this.props;
        let tags = data.data.tags ? data.data.tags : [];
        const promoteDesc = ymbj.promoteDesc;

        let dpjContent = '', lvjContent = '';
        if(data.tagInfos) {
            let {dpj, lvj, result} = this.getTypeValue(data.tagInfos, 'tag_type', 'shopAllianceCoupon', 'title');
            dpjContent = dpj;
            lvjContent = lvj;
            !tags.length && (tags = result);
        }

        return (
            <div className="pro-info ">
                <div className="tit">{data.title}</div>
                <div className="tags lr-tags">
                    {
                        tags && tags.map((item) => {
                            const text = item.tag || item.title;
                            if(!text) return null;
                            return <div className="tags-item">{text}</div>;
                        })
                    }
                </div>
                <div className="dpmj-item">
                    瓜分可得
                    <span className="line"></span>
                    {lvjContent ? lvjContent : promoteDesc}
                </div>
                <div className={`${dpjContent ? 'dpmj-item': 'empty-item'}`}>
                    {
                        dpjContent ?
                            <div>
                                店铺劵
                                <span className="line"></span>
                                {dpjContent}
                            </div> : ''
                    }
                </div>
                <div className="price-info">
                    <div className="price lr-price">&yen;<span className="num">{data.taocanPrice ? data.taocanPrice : data.price}</span>起</div>
                    <div className={`btn ${data.status === 2 ? 'soldout' : 'lr-btn'}`} >{data.status === 2 ? '已售罄' : '立即购买'}</div>
                </div>
            </div>
        );
    }
    render() {
        const {sqwzb, jump, ymbj} = this.props;
        const {sqwzbFirstTab = [], pros = []} = sqwzb;
        if(ymbj.shwzb && ymbj.shwzb.switch !== 1) return null;
        return (
            <div className="m-aroundsummer m-floor" id="sqwzb">
                <ModuleTitle name="sqwzb"/>
                {
                    sqwzbFirstTab.length > 1 ?
                        <Nav
                            tabs={sqwzbFirstTab}
                            tabClick={(keyName, index)=> {
                                this.tabClick(keyName, index);
                                sendSK('click_sqwzb_tab' + (index + 1));
                            }}
                            navCls="common-navitem"
                            navClsAct="common-navactive"
                            moreCls="common-navitem"
                            dbackCls="common-drawback"
                            keyName="sqwzbFirstTab"
                        /> : ''
                }
                {
                    pros.length ?
                        <div className="pro-lists">
                            {
                                pros.map((item, index) => {
                                    if(index > 5) return '';
                                    return <ProductItem
                                        data={item}
                                        custCls="lr-item"
                                        pRendeStatus={true}
                                        jump={() => {
                                            jump(item.jumpInfo, 'shuqi_sqwzb');
                                            sendSK('click_sqwzb', {
                                                floor: '暑期玩周边',
                                                id: item.id
                                            });
                                        }}
                                        key={index}
                                        pRend={this.pRend.bind(this)}
                                    />;
                                })
                            }
                        </div> : ''
                }
                {
                    pros.length ?
                        <MoreTitle
                            bgUrl={'//s.qunarzz.com/vacation_tuan/2020/06_shuchu/more-bg.png'}
                            text="查看更多"
                            ClickMore={() => {
                                let item = sqwzbFirstTab.filter((val) => val.checked)[0];
                                jump(item.more, 'shuqi_sqwzb_more');
                                sendSK('click_sqwzb_more', {
                                    floor: '暑期玩周边'
                                });
                            }}
                        /> : ''
                }
            </div>
        );
    }
}

export default AroundRecommend;